import type { AgentApproval, AgentIO, AgentMode, AgentStepId } from "./types";

/** Thrown into a pending question or approval when the user closed the modal. */
export class AgentCancelledError extends Error {
    constructor() {
        super("Agent run cancelled");
    }
}

interface ApproveDeps {
    mode(): AgentMode;
    stepId(): AgentStepId | undefined;
    isCancelled(): boolean;
    ask: AgentIO["ask"];
    post: AgentIO["post"];
    update: AgentIO["update"];
}

/** Builds `AgentIO.approve`: asks in Genehmigung, auto-approves in Schnell unless the approval sets askInQuick. */
export const createApprove =
    (deps: ApproveDeps): AgentIO["approve"] =>
    async ({ textId, values, goLabelId, learnMoreId, askInQuick }: AgentApproval) => {
        const stepId = deps.stepId();
        const auto = deps.mode() === "quick" && stepId !== undefined && askInQuick !== true;
        if (auto && deps.isCancelled()) throw new AgentCancelledError();
        const card = { learnMoreId, goLabelId };
        const id = deps.post({ kind: "approval", textId, values, approval: auto ? { ...card, answer: "auto" } : card });
        if (auto) {
            return true;
        }
        const answer = await deps.ask(
            textId,
            [
                { value: "go", labelId: goLabelId, primary: true },
                { value: "skip", labelId: "app.agent.approve.skip" },
            ],
            values,
            { silent: true },
        );
        deps.update(id, { approval: { ...card, answer } });
        return answer === "go";
    };
